import { useMutation, useQueryClient } from '@tanstack/react-query'
import apiClientPlatform from '@/apiClientPlatform'
import type {
  PlatformDeleteOwnerBody,
  PlatformDeleteOwnerResponse,
} from '@/types/platform'

export const useDeleteOwnerMutation = (ownerId: string) => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (payload: PlatformDeleteOwnerBody) => {
      const { data } =
        await apiClientPlatform.patch<PlatformDeleteOwnerResponse>(
          `/platform/owners/${ownerId}/delete`,
          payload
        )
      return data
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['platformOwners'] })
      await qc.invalidateQueries({
        queryKey: ['platformOwnerOverview', ownerId],
      })
      await qc.invalidateQueries({ queryKey: ['platformOwner', ownerId] })
      await qc.invalidateQueries({ queryKey: ['platformAudit'] })
      await qc.invalidateQueries({ queryKey: ['platformRegistrationBlocks'] })
    },
  })
}
